"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FocusFirstFocusableElement = exports.removeClass = exports.AddClass = exports.Focus = exports.Show = exports.Hide = void 0;
function Hide(element) {
    if (element instanceof NodeList) {
        for (var index = 0; index < element.length; index++) {
            var item = element[index];
            item.setAttribute("aria-hidden", "true");
        }
    }
    else {
        element.setAttribute("aria-hidden", "true");
    }
}
exports.Hide = Hide;
function Show(element) {
    if (element) {
        element.setAttribute("aria-hidden", "false");
    }
}
exports.Show = Show;
function Focus(element) {
    if (element) {
        element.focus();
    }
}
exports.Focus = Focus;
function AddClass(element, className) {
    element.classList.add(className);
}
exports.AddClass = AddClass;
function removeClass(element, className) {
    element.classList.remove(className);
}
exports.removeClass = removeClass;
function FocusFirstFocusableElement(element) {
    var firstFocus = element.querySelectorAll('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]');
    var focusableEls = Array.prototype.slice.call(firstFocus);
    var firstFocusableEl = focusableEls[0];
    if (firstFocusableEl) {
        firstFocusableEl.focus();
    }
}
exports.FocusFirstFocusableElement = FocusFirstFocusableElement;
